
























































































import { Vue, Component, Prop } from "vue-property-decorator";
import copyright from "@/components/footer/index.vue";
import { upload, uploadPercent, resetUploadPercent } from "@/http/grace.api";
import { addGoods, getGoodsDetail, editGoods } from "@/http/goods";
import { Form } from "element-ui";
import { GoodsDetail } from "@/interface/goods";
@Component({
  components: {
    copyright
  }
})
export default class OldgoodsAdd extends Vue {
  validateImg(rule: any, value: any, callback: Function) {
    const len = this.imgFileList.length;

    if (!len) {
      return callback("照片不能为空");
    } else {
      const res = this.imgFileList.some(ele => ele.size / 1024 / 1024 > 1);
      if (res) {
        return callback("照片最大限制为1mb");
      }
      callback();
    }
  }
  @Prop() id!: number;
  imgFileList: Array<any> = [];
  videoFileList: Array<any> = [];
  formData: any = {
    companyName: "", //单位名称
    name: "",
    year: "",
    description: "",
    oldObjectImages: [],
    videoUrl: ""
  };
  percent = 0;
  loading = false;
  rules = {
    companyName: [
      { required: true, message: "单位名称不能为空", trigger: "blur" }
    ],
    name: [{ required: true, message: "老物件名称不能为空", trigger: "blur" }],
    year: [{ required: true, message: "年份不能为空", trigger: "blur" }],
    description: [{ required: true, message: "描述不能为空", trigger: "blur" }],
    oldObjectImages: [
      { required: true, validator: this.validateImg, trigger: "change" }
    ]
  };
  hiddenAdd() {
    const addElement: any = document.querySelector(".el-upload--picture-card");
    if (this.imgFileList.length >= 3) {
      addElement.style.display = "none";
    } else {
      addElement.style.display = "inline-block";
    }
  }
  handleImgChange(files: any, fileList: any) {
    this.imgFileList = fileList;
    this.hiddenAdd();
  }
  handleImgRemove(file: any, fileList: any) {
    this.imgFileList = fileList;
    this.hiddenAdd();
  }

  handleVideoRemove(file: any, fileList: any) {
    this.videoFileList = fileList;
  }
  handleVideoChange(files: any, fileList: any) {
    this.videoFileList = fileList;
  }
  async getGoodsDetail() {
    try {
      const res = await getGoodsDetail({ id: this.$route.query.id });
      for (const key in this.formData) {
        if (key === "videoUrl") {
          if (res.videoUrl) {
            this.videoFileList = [
              {
                name: res.videoUrl
              }
            ];
          }
          /* eslint-disable */
        } else if (key === "oldObjectImages") {
          this.imgFileList = res.oldObjectImages.map(ele => ({
            folderUrl: ele.url,
            url: window.StaticUrl + ele.url,
            uid: Math.random()
          }));
        } else {
          this.formData[key] = res[key];
        }
      }
      this.hiddenAdd();
    } catch (error) {
      console.log(error);
    }
  }
  mounted() {
    if (this.$route.query.id) {
      this.getGoodsDetail();
    }
  }
  getUploadParams() {
    const data = new FormData();
    const imgNotUpload: Array<any> = [];
    const { imgFileList, videoFileList } = this;
    const sort: any = {};
    imgFileList.forEach((ele: any, index: number) => {
      if (ele.raw) {
        data.append("imgs", ele.raw);
      } else {
        imgNotUpload.push({ url: ele.folderUrl });
      }
    });
    videoFileList.forEach((ele: any) => {
      if (ele.raw) {
        data.append("video", ele.raw);
      }
    });
    return { data, imgNotUpload, sort };
  }
  // async upload() {
  //   const data = new FormData();
  //   const { imgFileList, videoFileList } = this;
  //   imgFileList.forEach((ele: any, index: number) => {
  //     if (ele.raw) {
  //       data.append("imgs", ele.raw);
  //     }
  //   });
  //   videoFileList.forEach((ele: any) => {
  //     if (ele.raw) {
  //       data.append("video", ele.raw);
  //     }
  //   });
  //   return await upload(data);
  // }
  checkFormDataIsEmpty(data: FormData) {
    let i = 0;
    for (const iterator of data.entries()) {
      i++;
    }
    return !!i;
  }
  publish() {
    !this.$route.query.id ? this.submit() : this.edit();
  }
  timer: any = null;
  uploadPercent() {
    const timer = setInterval(() => {
      this.percent += 1;
      if (this.percent >= 100) {
        clearInterval(timer);
        this.percent = 0;
      }
    }, 300);
  }
  async submit() {
    const ref = this.$refs.formData as any;
    const res = await ref.validate();
    if (!res) return;
    try {
      this.loading = true;
      const { data: uploadParams, imgNotUpload, sort } = this.getUploadParams();
      // await resetUploadPercent();
      this.uploadPercent();
      const uploadRes = await upload(uploadParams);
      const data = { ...this.formData };
      data.oldObjectImages = uploadRes.imgs.map((ele: any, index: number) => {
        return { url: ele, cover: index === 0 };
      });
      data.videoUrl = uploadRes.video[0];
      await addGoods(data);
      await this.$alert("发布成功");
      this.$router.push("/person-center");
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
      this.percent = 0;
    }
  }
  async edit() {
    const ref = this.$refs.formData as any;
    const res = await ref.validate();
    if (!res) return;
    try {
      this.loading = true;
      const data = { ...this.formData };
      if (this.$route.query.id) {
        data.id = +this.$route.query.id;
      }
      const { data: uploadParams, imgNotUpload, sort } = this.getUploadParams();
      if (this.checkFormDataIsEmpty(uploadParams)) {
        this.uploadPercent();
        const uploadRes = await upload(uploadParams);
        data.oldObjectImages = uploadRes.imgs.map((ele: any, index: number) => {
          return { url: ele };
        });
        data.videoUrl = uploadRes.video[0];
      }
      data.oldObjectImages = data.oldObjectImages.concat(imgNotUpload);
      data.oldObjectImages[0].cover = true;
      if (!data.videoUrl && this.videoFileList.length) {
        data.videoUrl = this.videoFileList[0].name;
      }
      console.log(typeof editGoods);
      await editGoods(data);
      this.loading = false;
      this.percent = 100;
      await this.$alert("发布成功");
      this.$router.push("/person-center");
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
      this.percent = 100;
    }
  }
}
